import { render, staticRenderFns } from "./ShiftsTable.vue?vue&type=template&id=0bac42ec"
import script from "./ShiftsTable.vue?vue&type=script&lang=js"
export * from "./ShiftsTable.vue?vue&type=script&lang=js"
import style0 from "./ShiftsTable.vue?vue&type=style&index=0&id=0bac42ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports